/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_EventInputs */

const th_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตามรายการนี้`)
};

const en_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow event`)
};

const ja_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会をフォロー`)
};

const zh_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注赛事`)
};

const es_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir evento`)
};

const pt_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguir evento`)
};

const id_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti acara`)
};

const fr_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivre l’événement`)
};

const tl_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sundan ang event`)
};

const vi_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi sự kiện`)
};

const ko_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 팔로우`)
};

const de_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event folgen`)
};

const ru_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписаться на событие`)
};

const tr_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinliği takip et`)
};

const it_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segui l'evento`)
};

const pl_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwuj wydarzenie`)
};

const uk_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стежити за подією`)
};

const hi_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन फ़ॉलो करें`)
};

const ar_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متابعة الفعالية`)
};

const ms_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti acara`)
};

const bn_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন অনুসরণ করুন`)
};

const zh_tw2_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤賽事`)
};

const zh_hk2_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤賽事`)
};

const ur_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ فالو کریں`)
};

const fa_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دنبال کردن رویداد`)
};

const sw_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuatilia tukio`)
};

const nl_follow_event = /** @type {(inputs: Follow_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenement volgen`)
};

/**
* | output |
* | --- |
* | "Follow event" |
*
* @param {Follow_EventInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const follow_event = /** @type {((inputs?: Follow_EventInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_EventInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_follow_event(inputs)
	if (locale === "ja") return ja_follow_event(inputs)
	if (locale === "zh") return zh_follow_event(inputs)
	if (locale === "es") return es_follow_event(inputs)
	if (locale === "pt") return pt_follow_event(inputs)
	if (locale === "id") return id_follow_event(inputs)
	if (locale === "fr") return fr_follow_event(inputs)
	if (locale === "tl") return tl_follow_event(inputs)
	if (locale === "vi") return vi_follow_event(inputs)
	if (locale === "ko") return ko_follow_event(inputs)
	if (locale === "de") return de_follow_event(inputs)
	if (locale === "ru") return ru_follow_event(inputs)
	if (locale === "tr") return tr_follow_event(inputs)
	if (locale === "it") return it_follow_event(inputs)
	if (locale === "pl") return pl_follow_event(inputs)
	if (locale === "uk") return uk_follow_event(inputs)
	if (locale === "hi") return hi_follow_event(inputs)
	if (locale === "ar") return ar_follow_event(inputs)
	if (locale === "ms") return ms_follow_event(inputs)
	if (locale === "bn") return bn_follow_event(inputs)
	if (locale === "zh-TW") return zh_tw2_follow_event(inputs)
	if (locale === "zh-HK") return zh_hk2_follow_event(inputs)
	if (locale === "ur") return ur_follow_event(inputs)
	if (locale === "fa") return fa_follow_event(inputs)
	if (locale === "sw") return sw_follow_event(inputs)
	if (locale === "nl") return nl_follow_event(inputs)
	return en_follow_event(inputs)
});